import type { ConversationAttachmentResponse } from '../model/api/types';

/**
 * Поля вложения, по которым определяется источник его файла. Их несут вложения карточки диалога,
 * элемента переписки и фразы транскрипта; у вложения фразы признаков недоступности и локального
 * файла нет — его источник определяется по ссылке.
 */
export type AttachmentFileSource = Pick<
  ConversationAttachmentResponse,
  'id' | 'url' | 'isExternalUrl' | 'isUnavailable' | 'hasLocalFile'
>;

/**
 * Откуда берётся файл вложения:
 * - `unavailable` — получить нельзя, вложение не открывается;
 * - `external` — внешняя ссылка, открывается как есть;
 * - `signed` — файл во внутреннем хранилище, открывается подписанной ссылкой;
 * - `local` — файл в локальном хранилище, отдаётся сервером целиком.
 */
type AttachmentSourceKind = 'unavailable' | 'external' | 'signed' | 'local';

/**
 * Источник файла вложения — одно правило на ленту переписки и вкладку «Вложения». Недоступность
 * перевешивает всё: такое вложение не открывается, каким бы ни был его источник. Вложение без
 * единого источника тоже недоступно.
 */
export const getAttachmentSourceKind = (attachment: AttachmentFileSource): AttachmentSourceKind => {
  if (attachment.isUnavailable) return 'unavailable';
  if (attachment.isExternalUrl) return attachment.url ? 'external' : 'unavailable';
  if (attachment.url) return 'signed';
  if (attachment.hasLocalFile) return 'local';
  return 'unavailable';
};
